import React/*, { useState }*/ from 'react';
//import { Link } from 'react-router-dom';
import ListTable from 'components/table/ListTable';
import RenderButtons from 'components/table/RenderButtons';
import { useUIUtils } from 'hooks/useUIUtils';
import { BotonNuevo, nombreEstatus, siNo, sucursalActual } from '../comun';

const List = ({ match }) => {
    const { path } = match;
    const { changeGlobalTitle } = useUIUtils();
    //const [pendientes, setPendientes] = useState([]);
    //const [tituloPendientes, setTituloPendientes] = useState('');

    React.useEffect(() => {
        changeGlobalTitle('Cajas', 'Listado de cajas del punto de venta.');
    }, [changeGlobalTitle]);


    const columns = [
        { renderCell: RenderButtons, headerName: '', maxWidth: 20, path: path, opciones: 'editar' },
        {
            field: 'id', headerName: 'Id', maxWidth: 70, renderCell: (params) => (
                <a href={`${path}/edit/${params.row.id}`}>{params.value}</a>)
        },
        {
            field: 'nombre', headerName: 'Nombre', minWidth: 180, renderCell: (params) => (
                <a href={`${path}/edit/${params.row.id}`}>{params.value}</a>)
        },
        { field: 'abierta', headerName: 'Abierta', minWidth: 100, valueGetter: (value) => value ? 'Si' : 'No' },
        { field: 'permite_Cobrar', headerName: 'Cobra', minWidth: 90, valueGetter: (value) => siNo(value) },
        { field: 'modificar_Almacen', headerName: 'Cambia almacen', minWidth: 140, valueGetter: (value) => siNo(value) },
        { field: 'estutus', headerName: 'Estatus', minWidth: 100, valueGetter: (value) => nombreEstatus(value) }
    ];

    return (
        <div className='container-fluid'>
            <div className='col-md-12 mb-2'>
                <BotonNuevo to={`${path}/add`} />
            </div>
            <div className='col-md-12'>
                <ListTable
                    columns={columns}
                    path={path}
                    url={`pv/PvCajas/GetList?sucursal_Id=${sucursalActual()}`}
                />
            </div>
        </div>
    );
};

export { List };
